<template>
  <div class="login-component">
    <div class="global_popup_header">
      {{ $t("login.title") }}
      <LangSelect class="login-langSelect"></LangSelect>
    </div>
    <div class="global_popup_body">
      <el-form
        label-position="top"
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        @submit.native.prevent
      >
        <el-form-item :label="$t('login.account')" prop="user">
          <el-input
            v-model="ruleForm.user"
            @keyup.enter.native="submitForm('ruleForm')"
            :placeholder="$t('login.account')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.password')" prop="pass">
          <el-input
            v-model="ruleForm.pass"
            type="password"
            @keyup.enter.native="submitForm('ruleForm')"
            :placeholder="$t('login.password')"
          ></el-input>
        </el-form-item>
        <el-form-item class="operation-wrap">
          <el-checkbox v-model="checked">{{ $t("login.auto") }}</el-checkbox>
          <span @click="forgetHandle" class="btn-wrap">{{
            $t("login.forget")
          }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="global_popup_footer">
      <button @click="submitForm('ruleForm')">{{ $t("login.logIn") }}</button>
    </div>
  </div>
</template>

<script>
import LangSelect from "@/components/langSelect";
export default {
  name: "Login",
  components: {
    LangSelect,
  },
  computed: {
    rules() {
      const rules = {
        user: [
          { required: true, message: this.$t("verify.user"), trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.$t("verify.password"),
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      checked: false,
      ruleForm: {
        user: "",
        pass: "",
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },

    async submit() {
      try {
        let res = await this.$http.login(this.ruleForm);
        this.$cookie.set("token", res.data.token);
        this.saveAccount(this.checked, this.ruleForm);
        if (
          this.$route.query &&
          this.$route.query.redirect &&
          this.$route.query.redirect !== "/index"
        ) {
          this.$router.push({ path: this.$route.query.redirect });
        } else {
          this.$router.push({ name: "bookstack" });
        }
      } catch (err) {
        this.elMsg(err.response.data.message, "error");
      }
    },

    forgetHandle() {
      this.$emit("changeComponent");
    },

    saveAccount(check, data) {
      if (check) {
        let user = escape(JSON.stringify(data));
        window.localStorage.setItem("account", user);
      } else {
        window.localStorage.removeItem("account");
      }
    },

    autoLogin(local) {
      if (local) {
        this.checked = true;
        this.ruleForm = JSON.parse(unescape(local));
      }
    },
  },
  created() {
    this.autoLogin(window.localStorage.getItem("account"));
  },
};
</script>

<style lang="scss">
.login-component {
  @include globalPopup(460px, 390px);
  .global_popup_body {
    .operation-wrap {
      margin: 0;
      .el-form-item__content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn-wrap {
          cursor: pointer;
        }
        &::before,
        &::after {
          content: normal;
        }
      }
    }
  }
  .login-langSelect {
    position: absolute;
    right: 10px;
    bottom: 2px;
  }
}
</style>
